import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

export type ViewMode = 'compact' | 'expanded';

interface AdminViewModeContextProps {
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
}

const AdminViewModeContext = createContext<AdminViewModeContextProps | undefined>(undefined);

export const AdminViewModeProvider: React.FC<{children: ReactNode}> = ({ children }) => {
  const [viewMode, setViewMode] = useState<ViewMode>('expanded');

  // Load from localStorage on mount
  useEffect(() => {
    const stored = localStorage.getItem('adminViewMode');
    if (stored === 'compact' || stored === 'expanded') {
      setViewMode(stored);
    }
  }, []);

  // Persist changes
  const updateMode = (mode: ViewMode) => {
    setViewMode(mode);
    localStorage.setItem('adminViewMode', mode);
  };

  return (
    <AdminViewModeContext.Provider value={{ viewMode, setViewMode: updateMode }}>
      {children}
    </AdminViewModeContext.Provider>
  );
};

export const useAdminViewMode = (): AdminViewModeContextProps => {
  const context = useContext(AdminViewModeContext);
  if (!context) {
    throw new Error('useAdminViewMode must be used within AdminViewModeProvider');
  }
  return context;
};
